import { CardShimmer, SectionHeaderWithCardShimmer, TextShimmer } from 'components/molecules/Shimmer';
import React from 'react';

const BusinessDetailsChargesShimmer: React.FC = () => {
	return (
		<>
			<SectionHeaderWithCardShimmer
				cardWrapperClass="mx4"
				sectionHeaderWrapperClass="mt16 mb4 mx4"
				showRightContent={false}
				cardHeight={210}
			/>
			<SectionHeaderWithCardShimmer
				cardWrapperClass="mx4"
				sectionHeaderWrapperClass="my6 mx4"
				showRightContent={false}
				cardHeight={170}
			/>
			<CardShimmer wrapperClassName="mx4 my4" height={160} width="100%" />
			<TextShimmer width={'calc(100% - 32px)'} height={18} component="div" className="mx4" />
			<TextShimmer width={'calc(100% - 32px)'} height={18} component="div" className="mx4" />
			<CardShimmer wrapperClassName="mx4 my4" height={50} width="100%" />
		</>
	);
};

export default BusinessDetailsChargesShimmer;
